// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btns-wrap[data-v-b01a292a]{display:flex;justify-content:center;flex-wrap:wrap;grid-gap:15px;gap:15px}", ""]);
// Exports
module.exports = exports;
